import { IconQuestionMark } from "@tabler/icons-react";

export interface IconProps {
  filename?: string;
  description?: string;
  height?: number;
  width?: number;
}

const Icon = ({
  filename, description, height = 20, width = 20,
}: IconProps) => (filename
  ? <img height={`${height}px`} width={`${width}px`} src={`../../assets/${filename}`} alt={description ?? filename} />
  : <IconQuestionMark />);

export default Icon;
